export const WEBSITE = {
    DOMAIN: 'www.docchatservice.com'
}